jQuery( document ).ready( function ($) {
  if(typeof pagegestaoambiental !== 'undefined') {

  }
});
